import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../../services/authService';
import Button from '../../components/common/Button/Button';
import cosmicLogo from '../../assets/images/cosmic-logo.png';
import styles from './Login.module.css';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('student');

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate passwords match
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    // Validate password length
    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);

    try {
      const response = await register(email, password, role);
      
      // Store token and redirect
      localStorage.setItem('token', response.access_token);
      
      // Redirect based on role and onboarding status
      if (['mentor', 'student', 'counsellor'].includes(response.user.role)) {
        navigate(`/${response.user.role}/onboarding`);
      } else {
        const roleRoutes = {
          'super_admin': '/super-admin/dashboard',
          'manager': '/manager/dashboard',
        };
        const route = roleRoutes[response.user.role] || '/login';
        navigate(route);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.header}>
          <img src={cosmicLogo} alt="COSMIC Logo" className={styles.logoImage} />
          <h1 className={styles.logo}>COSMIC</h1>
          <p className={styles.subtitle}>Register New Account</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.label}>Email *</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.input}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="role" className={styles.label}>Role *</label>
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className={styles.input}
              required
            >
              <option value="student">Student</option>
              <option value="mentor">Mentor</option>
              <option value="counsellor">Counsellor</option>
              {/* <option value="manager">Manager</option> */}
            </select>
            <small style={{ color: '#888', fontSize: '0.85rem', marginTop: '4px', display: 'block' }}>
              Select the role that matches your responsibilities
            </small>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password" className={styles.label}>Password *</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input}
              placeholder="Enter your password (min 6 characters)"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="confirmPassword" className={styles.label}>Confirm Password *</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className={styles.input}
              placeholder="Confirm your password"
              required
            />
          </div>



          {error && (
            <div className={styles.error}>
              {error}
            </div>
          )}

          <Button type="submit" loading={loading}
            variant="primary"
            fullWidth
            disabled={loading}
            
          >
            {loading ? 'Registering...' : 'Register'}
          </Button>
        </form>

        <div className={styles.footer}>
          <p>
            Already have an account? <Link to="/login" style={{ color: '#4a90e2' }}>Login here</Link>
          </p>
          <p style={{ marginTop: '10px' }}>© 2025 CreatED. All rights reserved.</p>
          <p style={{ marginTop: '8px', fontSize: '11px', color: '#666' }}>
            Dev Team: {' '}
            <a 
              href="https://www.linkedin.com/in/sankar4/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#0077b5', textDecoration: 'none' }}
            >
              Sankar Balasubramanian
            </a>
            {' & '}
            <a 
              href="https://www.linkedin.com/in/aashna-saraf-324463166/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#0077b5', textDecoration: 'none' }}
            >
              Aashna Saraf
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
